import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/15-1_trash.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const Trash: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default Trash;
